import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent, VisibilityFilterPipe } from './app.component';
import { DashboardComponent } from './Dashboard/dashboard.component';
//import { ProductModule } from './Components/Product/product.module';
import { CoreModule } from './Shared/core.module';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

//import { CollectionsModule } from './Components/CommonCollections/collections.module';
//import { AppSettingsModule } from './Components/ApplicationSettings/appsettings.module';
//import { TransactionModule } from './Components/Transaction/transaction.module';

//Added by Santosh
//import { MatPaginatorModule, MatProgressBarModule, MatSnackBarModule, MatSortModule, MatTableModule, MatTabsModule } from '@angular/material';
import { JitCompilerModule } from '@codehint-ng/html-compiler';

import { MatListModule } from "@angular/material/list";
import { MatSidenavModule } from "@angular/material/sidenav";
import { MatToolbarModule } from "@angular/material/toolbar";
import { MatButtonModule } from "@angular/material/button";
import { MaterialModule } from './Components/material.module';
import { MAT_DATE_LOCALE } from '@angular/material/core';

import { MenuListItemComponent } from "./Components/Controls/Menu-List-Item/menu-list-item.component";
import { TopNavComponent } from "./Components/Controls/Top-Nav/top-nav.component";
import { DatePipe, APP_BASE_HREF, CommonModule } from '@angular/common';

import { jqxGridModule } from 'jqwidgets-ng/jqxgrid';
import { DailyCollectionComponent } from './Dashboard/dailyCollection.component';
import { ExpiringSubscriptionsComponent } from './Dashboard/expiringSubscriptions.component';
import { FollowupComponent } from './Dashboard/followup.component';

//Modal Popup
//import { Ng2Bs3ModalModule } from 'ng2-bs3-modal/ng2-bs3-modal';
//Datatable with Pagination
//import { DataTableModule } from "angular2-datatable-serverpagination";
//import { DataFilterPipe }   from './data-filter.pipe';
//TODO:Santosh
//import {NgxPaginationModule} from 'ngx-pagination';

import { NavService } from './Services/nav.service';

//Fitness Centre Starts
//import { FitnessCentreModule } from './Components/FitnessBox/fitnessbox.module';
//Fitness Centre Ends
import { AppContext } from './Shared/common';
import { NgbModule, NgbPopoverModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxPrintModule } from 'ngx-print';

// Auth
import { OrgInterceptor } from './Services/org.interceptor';
import { AppInitializer } from './Services/app-initializer';
import { OrgInputComponent } from './Components/Auth/org-input.component';
import { OrgSelectorComponent } from './Components/Auth/org-selector.component';
import { LoginComponent } from './Components/Auth/login.component';
import { AuthGuard } from './Services/auth.guard';
import { OrgInitGuard } from './Services/org-init.guard';
import { AppRedirectorComponent } from './appRedirector';
import { RestrictedAccessComponent } from './app.restricted.access';

@NgModule({
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    //ProductModule,
    CoreModule,
    //CollectionsModule,
    //AppSettingsModule,
    //TransactionModule,
    JitCompilerModule,
    MatIconModule,
    MatListModule,
    MatSidenavModule,
    MatToolbarModule,
    MatButtonModule,
    //FitnessCentreModule,
    jqxGridModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    NgbPopoverModule,
    CommonModule,
    NgxPrintModule,
    MatProgressSpinnerModule
  ],
  declarations: [
    AppComponent,
    VisibilityFilterPipe,
    DashboardComponent,
    DailyCollectionComponent,
    ExpiringSubscriptionsComponent,
    FollowupComponent,
    MenuListItemComponent,
    TopNavComponent,
    OrgInputComponent,
    OrgSelectorComponent,
    LoginComponent,
    AppRedirectorComponent,
    RestrictedAccessComponent
  ],
  bootstrap: [AppComponent],
  providers: [
    NavService,
    AppContext,
    DatePipe,
    { provide: MAT_DATE_LOCALE, useValue: 'en-GB' },
    { provide: HTTP_INTERCEPTORS, useClass: OrgInterceptor, multi: true },
    AuthGuard,
    OrgInitGuard
  ]
})
export class AppModule { }
